import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface StoryPaymentReceiptObject {
 errorStatus: boolean;
 message: string;
 show: boolean;
}

const initialState: StoryPaymentReceiptObject = {
 errorStatus: true,
 message: '',
 show: false,
};

export const storyPaymentReceiptResponseStatusSlice = createSlice({
 name: 'storyPaymentReceiptResponseStatus',
 initialState,
 reducers: {
  storyPaymentReceiptResponseStatus: (
   state,
   action: PayloadAction<StoryPaymentReceiptObject>,
  ) => {
   state = action.payload;
   return state;
  },
 },
});

export const { storyPaymentReceiptResponseStatus } =
 storyPaymentReceiptResponseStatusSlice.actions;

export default storyPaymentReceiptResponseStatusSlice.reducer;
